import { gql } from '@apollo/client';

export const GET_SKUS_BY_ID = gql`
  query GetSkusByIds($ids: [ID!]!) {
    getSkusByIds(ids: $ids) {
      id
      productId
      name

      value
      providerId
      upayId
      createdAt
      updatedAt
      product {
        id
        name

        siteIds
        shortDescription

        fullDescription

        instruction

        terms

        sorting
        image
        countries
        baseCurrencyId
        categoryId
        createdAt
        updatedAt
        baseCurrency {
          id
          name
        }
        category {
          id
          name
          image
          sorting
          parentId
          createdAt
          updatedAt
          parent {
            id
            name
            image
            sorting
            parentId
            createdAt
            updatedAt
          }
          children {
            id
            name
            image
            sorting
            parentId
            createdAt
            updatedAt
          }
        }
        skus {
          id
          productId
          name

          value
          providerId
          upayId
          createdAt
          updatedAt
        }
        preset {
          isPreset
          presetName
        }
      }
      carts {
        id
        userId
        skuId
        quantity
        sku {
          id
          productId
          name

          value
          providerId
          upayId
          createdAt
          updatedAt
        }
      }
    }
  }
`;
